import { FeaturePost } from '../FeaturePosts';

export const doctorSummaryPdf: FeaturePost = {
  id: 'doctor-summary-pdf',
  cardImage: `${process.env.PUBLIC_URL}/assets/features/drsummary.png`,
  image: '',
  tag: 'Doctor visits',
  date: '2026-09-20',
  title: 'Export Your Doctor Summary as a PDF',
  subtitle: 'Bring a clear summary of your health to your next appointment',
  readTime: '3 min',
  content: `Appointments can be short, and it's easy to forget things in the moment. Toastie's doctor summary pulls your health history together so it's easier to explain what's been going on.

#### What's in the summary

- Your symptom trends over time
- Medications you've logged
- Insights and patterns Toastie has noticed
- Questions you might want to ask

#### Export as a PDF

You can now export your summary as a PDF to print, email, or show your doctor on your phone.

*Toastie's insights aren't medical advice. Always check with your doctor before making medical decisions.*`,
};
